import { z } from 'zod'

/**
 * Audit Log contract (Screen 8). Pinned to the backend's GET /api/audit
 * response — built to this exact shape in parallel. Read-only chronological log;
 * the server returns events newest-first and applies its own last-7-days default
 * when no date range is supplied.
 *
 * `detail` is an arbitrary event-specific JSON object (or null) — pretty-printed
 * in the expandable row. `old_value`/`new_value` carry settings-change diffs.
 * `event_types` is the full set of known types, used to populate the filter
 * select (independent of the current page's events).
 */

export const auditEventSchema = z.object({
  id: z.number(),
  event_type: z.string(),
  user_email: z.string().nullable(),
  shopify_order_id: z.string().nullable(),
  detail: z.record(z.string(), z.unknown()).nullable(),
  old_value: z.string().nullable(),
  new_value: z.string().nullable(),
  success: z.boolean(),
  error_message: z.string().nullable(),
  created_at: z.string(),
})
export type AuditEvent = z.infer<typeof auditEventSchema>

export const auditResponseSchema = z.object({
  total: z.number(),
  events: z.array(auditEventSchema),
  event_types: z.array(z.string()),
  generated_at: z.string(),
})
export type AuditResponse = z.infer<typeof auditResponseSchema>
